import axios from 'axios'

export default {
  getNotes(perPage, pageNumber) {
    const query = {
      params: {
        perPage,
        pageNumber
      }
    }
    return axios.get('/api/notifications', query)
  },
  sendNote(text, userId) {
    return axios.post('/api/notifications', { text, id: userId })
  },
  getUnreadNotes() {
    return axios.get('/api/notifications/count')
  },
  notificationsMakeRead(notesIds) {
    return axios.put('/api/notifications', { notifications: notesIds })
  },
  setRedirectEmails(emails) {
    return axios.put('/api/admins/emails/redirect', { emails })
  },
  getRedirectEmails() {
    return axios.get('/api/admins/emails/redirect')
  }
}
